import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([Navigation, Pagination]);

export default class Carousel {
  init() {
    // var windowSize = window.matchMedia("(max-width: 940px)");
    // const elements = document.querySelectorAll(".ImageGrid, .Carousel");
    const elements = document.querySelectorAll(".Carousel");

    if (!elements.length) return;

    // document.addEventListener("DOMContentLoaded", function () {});
    elements.forEach((element) => {
      const nextArrow = element.querySelector(".Carousel__nav-next");
      const prevArrow = element.querySelector(".Carousel__nav-prev");
      const pagination = element.querySelector(".Carousel__pagination");
      // const view = parseInt(element.getAttribute("data-view"), 10) || 1;
      const viewMobile =
        parseInt(element.getAttribute("data-view-mobile"), 10) || 1;
      const viewTablet =
        parseInt(element.getAttribute("data-view-tablet"), 10) || 1;
      const viewDesktop =
        parseInt(element.getAttribute("data-view-desktop"), 10) || 1;

      this.swiper = new Swiper(element, {
        // slidesPerView: 1,
        slidesPerView: viewMobile,
        loop: false,
        breakpoints: {
          768: {
            slidesPerView: viewTablet,
            spaceBetween: 0,
          },
          1024: {
            slidesPerView: viewDesktop,
            spaceBetween: 0,
          },
        },
        navigation: {
          nextEl: nextArrow,
          prevEl: prevArrow,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
      });
    });
  }
}
